import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, } from "@angular/forms";
import { SchemesProvider } from "../../shared/providers/schemes.provider";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SchemeModel } from "../../shared/models/scheme";
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-schemes-list',
  templateUrl: './schemes-list.component.html',
  styleUrls: ['./schemes-list.component.scss']
})
export class SchemesListComponent implements OnInit {

  formGroup;
  @Input() model = new SchemeModel

  schemes: any = []
  extendDateLimit;
  exlDownLoadUrl: any;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    public schemeProvider: SchemesProvider,
    public adminDataProvider: AdminDataProvider,
    private router: Router,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService,
  ) { }

  ngOnInit() {
    this.getSchame()
  }

  getSchame() {
    this.apiService.get(this.apiConfig.listScheme + `?scheme_id=`).subscribe((res: any) => {
      this.schemes = res.data
    })
  }

  extendScheme(targetModal, schemeData) {
    this.extendDateLimit = schemeData.end_date;
    this.formGroup = this.fb.group({
      program_id: 1,
      id: schemeData.id,
      end_date: new FormControl(schemeData.end_date, [Validators.required]),
    });
    this.openModal(targetModal);
  }


  openModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  onSubmitExtend(formGroup) {
    this.apiService.post(this.apiConfig.extendScheme + formGroup.id, formGroup)
      .subscribe((res) => {
        let itemIndex = this.schemes.findIndex(scheme => scheme.id === formGroup.id);
        this.schemes[itemIndex].end_date = formGroup.end_date;
        this.schemes = this.schemeProvider.schemes;
        this.modalService.dismissAll();

      }, err => {

      })
  }

  routeToConfigPage(scheme) {

    console.log(scheme)
    let scheme_config = {
      create: true,
      whitelist: true,
      colifire_whitelist: false,
      scheme_id: scheme.id
    }

    localStorage.setItem('scheme_config', JSON.stringify(scheme_config))
    this.router.navigateByUrl(`/hubAdmin/scheme-setup/${scheme.id}`)

  }

  routeToViewPage(scheme) {
    this.router.navigateByUrl('/hubAdmin/view-scheme/' + scheme.id)
  }

  routetoWhiteListUser(scheme) {
    console.log(scheme.id)
    this.router.navigateByUrl("/hubAdmin/Whitelistusers/" + scheme.id)
  }

  downloadSchemeExcel(singleScheme: any) {
    let downloadExcelapiUrl = this.apiConfig.downloadSchemeUserExcel + "&scheme_id=" + singleScheme.id;
    this.apiService.get(downloadExcelapiUrl)
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.toast.Success(res.data.message);
          this.exlDownLoadUrl = res.data.excel;
          setTimeout(() => {
            document.getElementById("downloadLink").click();
          }, 500);
        } else if (res.status == 201) {
          this.toast.Error(res.data.message);
        }
      }, err => {

      })

  }

  createScheme() {
    // this.editScheme()
    // return
    let scheme_config = {
      create: true,
      whitelist: false,
      colifire_whitelist: false,
      scheme_id: ''
    }

    localStorage.setItem('scheme_config', JSON.stringify(scheme_config))
    this.router.navigateByUrl(`/hubAdmin/scheme-setup/0`)

  }
  schemeStatus(data){
    let payload = {
      scheme_id:data.id,
      status:0
    }
    this.apiService.post(this.apiConfig.disableScheme,payload).subscribe((res:any)=>{
      console.log(res);
      this.getSchame();
    })
  }
}
